import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { readStates, states } from '@/constants/lifecycle';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import { showRoleActions } from '../actions';

const RoleActionsAction = ({
  category,
  code,
  readStatus,
  isEditing,
  showDialog,
  roleActions,
}) => (
  <RibbonMenu
    name="role-action"
    icon="external"
    message="actions.role-actions"
    className="whitespace-nowrap"
    disabled={isEditing || readStatus !== states.SUCCESS}
    onClick={() => showDialog(code, category, roleActions, readStatus)}
  />
);

const mapStateToProps = ({
  roles: { roles },
}, { category, code }) => {
  const role = findResult(roles, category, code)
      || { isEditing: false, system: true, ...readStates };
  const roleActions = role?.roleActions;

  return {
    readStatus: roleActions?.readStatus,
    isEditing: role?.isEditing,
    roleActions: roleActions?.items,
  };
};

const mapDispatchToProps = {
  showDialog: showRoleActions,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleActionsAction);
